import React from 'react';
import PropTypes from 'prop-types';
import SubscriptionSignature from './SubscriptionSignature';
import SubscriptionDiscountCodeBenefits from './SubscriptionDiscountCodeBenefits';

export default function SubscriptionInvoiceTerms({terms,onSignatureStatusChange}) {
  const details=terms || {};
  const units={Daily:'day',Weekly:'week',Fortnightly:'fortnight',Monthly:'month',Yearly:'year'};
  const unit=units[details.interval],interval=Number(details.interval_count),count=Number(details.payment_count);
  const valid=details.amount_minor!=null && Number.isFinite(Number(details.amount_minor)) && details.currency && unit && Number.isInteger(interval) && interval>0 && Number.isInteger(count) && count>=0;
  const money=amount=>`${details.currency} ${(Number(amount)/100).toFixed(2)}`;
  const frequency=interval===1?unit:`${interval} ${unit}s`;
  const recorded=details.agreement_status==='recorded';
  const inclusions=recorded && Array.isArray(details.inclusions)?details.inclusions:[];
  return <div className="col-12 fw-normal subscription-purchase-agreement">
    {details.payment_kind==='single' && details.amount_minor!=null && details.currency ? <div>Single payment · {money(details.amount_minor)}</div> : valid?<>
      <div>{count?`${count} payment${count===1?'':'s'}`:'Ongoing payments'} · {money(details.amount_minor)} every {frequency}</div>
      {details.custom_first_amount_minor!=null && <div>First payment: {money(details.custom_first_amount_minor)}</div>}
    </>:<div>Payment commitment details were not recorded for this historical purchase.</div>}
    {recorded?<>
      <div>Purchased inclusions</div>
      {inclusions.length?<ul>{inclusions.map((item,index)=><li key={`${item.kind}-${item.id}-${index}`}>
        {item.quantity==null?'Quantity unavailable':item.quantity} × {item.name || `${item.kind==='product'?'Product':'Service'} name unavailable`}
      </li>)}</ul>:<div>No service or product inclusions recorded for this purchase.</div>}
      {Number(details.voucher_amount_minor)>0 && <div>Voucher credit: {money(details.voucher_amount_minor)}</div>}
      {Number(details.product_discount_percent)>0 && <div>Product discount: {Number(details.product_discount_percent)}%</div>}
      {Number(details.expiry_months)>0 && <div>Benefits validity: {Number(details.expiry_months)} months</div>}
    </>:<div>Purchased inclusions were not recorded for this historical purchase.</div>}
    <SubscriptionDiscountCodeBenefits terms={details}/>
    <SubscriptionSignature signature={details.signature} onStatusChange={onSignatureStatusChange}/>
  </div>;
}
SubscriptionInvoiceTerms.propTypes={terms:PropTypes.object,onSignatureStatusChange:PropTypes.func};
